const rankings = [
  { rank: 1, title: '玫瑰的故事', meta: '热度 9.8', hot: true, tag: '新晋爆款' },
  { rank: 2, title: '唐朝诡事录之西行', meta: '热度 9.6', hot: true, tag: '口碑佳作' },
  { rank: 3, title: '长相思 第二季', meta: '热度 9.5', hot: true, tag: '全集上线' },
  { rank: 4, title: '你比星光美丽', meta: '热度 9.3', hot: false, tag: '热播中' },
  { rank: 5, title: '好搭档', meta: '热度 9.1', hot: false, tag: '韩剧热播' },
  { rank: 6, title: '少年白马醉春风', meta: '热度 8.9', hot: false, tag: '新番推荐' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热播榜单
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          实时热度排行，发现最受欢迎的电视剧
        </p>
        <div className="max-w-2xl mx-auto">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-4 border-b border-background-200/70 last:border-0 group cursor-pointer"
            >
              <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <span className="flex-1 text-sm md:text-base text-foreground-800 font-medium group-hover:text-primary-600 transition-colors duration-150">
                {item.title}
              </span>
              <span className="text-xs text-foreground-500 shrink-0 hidden sm:block">{item.meta}</span>
              <span className={`shrink-0 text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-100 text-primary-700'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}